<template>
  <div class='yytt_con'>
    <div class='block1 text_center'>
      <img src='@/assets/icons/ill_patterns_audio@2x.png' width='100%' alt='' class='bg1'>
      <img src='@/assets/icons/ill_star_audio@2x.png' width='100%' alt='' class='bg2'>
      <div class='w_1200 cf pos_r'>
        <dl class='fl text_left'>
          <dt>
            <h3>{{ $t('reading.funEnglish.title') }}</h3>
            <p>{{ $t('reading.funEnglish.desc') }}</p>
          </dt>
          <dd>
            <img src='@/assets/img/英阅听听.png' width='125px' height='125px' alt=''>
            <p v-if='device == "mobile"' v-html='$t("reading.funEnglish.qrcodeMobile")'></p>
            <p v-else>{{ $t('reading.funEnglish.qrcode') }}</p>
          </dd>
        </dl>
        <img class='fl' src='@/assets/icons/Group5@2x(1).png' width='380' height='738' alt=''>
        <img class='moon' src='@/assets/icons/ill_moon@2x.png' width='244' height='244' alt=''>
      </div>
    </div>
    <div class='block2 text_center'>
      <img src='@/assets/icons/Group6@2x.png' width='368' height='475' alt=''>
      <h3>{{ $t('reading.funEnglish.introTitle') }}</h3>
      <div class='text'>{{ $t('reading.funEnglish.introDesc') }}</div>
    </div>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
export default {
  name: 'ListenEnglish',
  components: { },
  data () {
    return {
      device: '',
    }
  },
  methods: {
    init () {
      this.device = mediaDevice()
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('reading.funEnglish.title')}`)
    this.init()
  },
}
</script>
